import React from "react";
import PropTypes from "prop-types";
import "./casino-customer-fieldset.scss";
import Input from "app/pages/.shared/form/Input";
import { FormattedMessage } from "react-intl";
import { PASSENGER_TYPE } from "app/constants";
import DateSelectorInput from "app/pages/.shared/DateSelector/DateSelectorInput";

class CasinoCustomerFieldset extends React.PureComponent {
	render() {
		const {
			maidenName = {},
			birthdate = {},
			zipCodeOfBirth = {},
			showMaidenName = false,
		} = this.props;
		return (
			<div className="casino-customer-fieldset">
				<div className="casino-customer-fieldset__title">
					<FormattedMessage id="payment.customer.title" />
				</div>

				{showMaidenName && (
					<div className="casino-customer-fieldset__maiden">
						<Input
							field={maidenName}
							label={<FormattedMessage id="casino.maiden.name.label" />}
							id="casino-maiden-name"
							name="casino-maiden-name"
						/>
					</div>
				)}

				<div className="casino-customer-fieldset__zipcode">
					<Input
						type="tel"
						field={zipCodeOfBirth}
						id="casino-zipcode"
						name="casino-zipcode"
						label={<FormattedMessage id="casino.zipcode.label" />}
						note={<FormattedMessage id="casino.zipcode.note" />}
					/>
				</div>
				<div className="casino-customer-fieldset__birthdate">
					<DateSelectorInput
						isChildrenAgeRequired={true}
						formatMonth="2-digit"
						label={<FormattedMessage id="casino.birthdate.label" />}
						fields={birthdate}
						id="casino-birthdate"
						name="casino-birthdate"
						type={PASSENGER_TYPE.ADULT}
					/>
				</div>
			</div>
		);
	}
}

CasinoCustomerFieldset.propTypes = {
	maidenName: PropTypes.string,
	birthdate: PropTypes.string,
	zipCodeOfBirth: PropTypes.string,
	showMaidenName: PropTypes.bool,
};

export default CasinoCustomerFieldset;
